import { useMutation, useQueryClient } from '@tanstack/react-query';
import { markNotificationAsRead } from '../../api/fetchers/notificationFetcher';

const useMarkNotificationAsRead = () => {
    const queryClient = useQueryClient();

    const { mutateAsync, isLoading, isError, error } = useMutation({
        mutationFn: (id) => markNotificationAsRead(id),
        onSuccess: async () => {
            await queryClient.invalidateQueries(['notifications']);
            await queryClient.invalidateQueries(['notifications-unread-count']);
        },
    });

    return {
        mutateAsync,
        isPending: isLoading,
        isError,
        error,
    };
};

export default useMarkNotificationAsRead;
